export default {
  kind: "customsearch#search",
  url: {
    type: "application/json",
    template:
      "https://www.googleapis.com/customsearch/v1?q={searchTerms}&num={count?}&start={startIndex?}&lr={language?}&safe={safe?}&cx={cx?}&sort={sort?}&filter={filter?}&gl={gl?}&cr={cr?}&googlehost={googleHost?}&c2coff={disableCnTwTranslation?}&hq={hq?}&hl={hl?}&siteSearch={siteSearch?}&siteSearchFilter={siteSearchFilter?}&exactTerms={exactTerms?}&excludeTerms={excludeTerms?}&linkSite={linkSite?}&orTerms={orTerms?}&relatedSite={relatedSite?}&dateRestrict={dateRestrict?}&lowRange={lowRange?}&highRange={highRange?}&searchType={searchType}&fileType={fileType?}&rights={rights?}&imgSize={imgSize?}&imgType={imgType?}&imgColorType={imgColorType?}&imgDominantColor={imgDominantColor?}&alt=json",
  },
  queries: {
    request: [
      {
        title: "Google Custom Search - tesla",
        totalResults: "365000000",
        searchTerms: "tesla",
        count: 10,
        startIndex: 1,
        inputEncoding: "utf8",
        outputEncoding: "utf8",
        safe: "off",
        cx: "6774990de52224e9d",
      },
    ],
    nextPage: [
      {
        title: "Google Custom Search - tesla",
        totalResults: "365000000",
        searchTerms: "tesla",
        count: 10,
        startIndex: 11,
        inputEncoding: "utf8",
        outputEncoding: "utf8",
        safe: "off",
        cx: "6774990de52224e9d",
      },
    ],
  },
  context: {
    title: "Google",
  },
  searchInformation: {
    searchTime: 0.81563,
    formattedSearchTime: "0.82",
    totalResults: "365000000",
    formattedTotalResults: "365,000,000",
  },
  items: [
    {
      kind: "customsearch#result",
      title: "Tesla: Electric Cars, Solar & Clean Energy",
      htmlTitle:
        "\u003cb\u003eTesla\u003c/b\u003e: Electric Cars, Solar &amp; Clean Energy",
      link: "https://www.tesla.com/",
      displayLink: "www.tesla.com",
      snippet:
        "Tesla is accelerating the world's transition to sustainable energy with electric cars\n, solar and integrated renewable energy solutions for homes and businesses.",
      htmlSnippet:
        "\u003cb\u003eTesla\u003c/b\u003e is accelerating the world&#39;s transition to sustainable energy with electric cars\u003cbr\u003e\n, solar and integrated renewable energy solutions for homes and businesses.",
      cacheId: "rHYp-0etoiEJ",
      formattedUrl: "https://www.tesla.com/",
      htmlFormattedUrl: "https://www.\u003cb\u003etesla\u003c/b\u003e.com/",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcR-Vu30eHPkiBGYbjI8D35E2A1CIWXwWHvnHU8wduqFSM6wZrHfntPXfBY",
            width: "246",
            height: "205",
          },
        ],
        metatags: [
          {
            "msapplication-tilecolor": "#cc0000",
            "og:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/195458a0-ff67-488c-b972-14d23d2c42fb/bvlatuR/std/1200x630/ms-homepage-social",
            "twitter:card": "summary_large_image",
            "twitter:title": "Electric Cars, Solar & Clean Energy | Tesla",
            "og:type": "website",
            "theme-color": "#000000",
            "og:site_name": "Tesla",
            "og:image:url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/195458a0-ff67-488c-b972-14d23d2c42fb/bvlatuR/std/1200x630/ms-homepage-social",
            handheldfriendly: "true",
            "twitter:url": "https://www.tesla.com/",
            "og:title": "Electric Cars, Solar & Clean Energy | Tesla",
            "msapplication-tileimage":
              "/themes/custom/tesla_frontend/assets/favicons/mstile-144x144.png",
            "twitter:creator": "@tesla",
            "og:description":
              "Tesla is accelerating the world's transition to sustainable energy with electric cars, solar and integrated renewable energy solutions for homes and businesses.",
            "twitter:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/195458a0-ff67-488c-b972-14d23d2c42fb/bvlatuR/std/1200x630/ms-homepage-social",
            "og:image:secure_url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/195458a0-ff67-488c-b972-14d23d2c42fb/bvlatuR/std/1200x630/ms-homepage-social",
            "twitter:site": "@tesla",
            "apple-mobile-web-app-status-bar-style": "black",
            viewport: "width=device-width, initial-scale=1.0",
            "twitter:description":
              "Tesla is accelerating the world's transition to sustainable energy with electric cars, solar and integrated renewable energy solutions for homes and businesses.",
            "apple-mobile-web-app-capable": "yes",
            mobileoptimized: "width",
            "og:url": "https://www.tesla.com/",
          },
        ],
        cse_image: [
          {
            src:
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/195458a0-ff67-488c-b972-14d23d2c42fb/bvlatuR/std/1200x630/ms-homepage-social",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title:
        "Tesla Q4 2020 Vehicle Production & Deliveries | Tesla Investor ...",
      htmlTitle:
        "\u003cb\u003eTesla\u003c/b\u003e Q4 2020 Vehicle Production &amp; Deliveries | \u003cb\u003eTesla\u003c/b\u003e Investor ...",
      link:
        "https://ir.tesla.com/press-release/tesla-q4-2020-vehicle-production-deliveries",
      displayLink: "ir.tesla.com",
      snippet:
        "Tesla Q4 2020 Vehicle Production & Deliveries. Globe Newswire. Jan 2, 2021. \nPALO ALTO, Calif., January 2, 2021 – In 2020, we produced and delivered half a\n ...",
      htmlSnippet:
        "\u003cb\u003eTesla\u003c/b\u003e Q4 2020 Vehicle Production &amp; Deliveries. Globe Newswire. Jan 2, 2021. \u003cbr\u003e\nPALO ALTO, Calif., January 2, 2021 – In 2020, we produced and delivered half a\u003cbr\u003e\n&nbsp;...",
      cacheId: "nq7ksFan47YJ",
      formattedUrl:
        "https://ir.tesla.com/press-release/tesla-q4-2020-vehicle-production-deliveries",
      htmlFormattedUrl:
        "https://ir.\u003cb\u003etesla\u003c/b\u003e.com/press-release/\u003cb\u003etesla\u003c/b\u003e-q4-2020-vehicle-production-deliveries",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcRFEIkCTtfdXb_TG82EyVnE1t4uZbKTjie6TD6X8SsCHGJEJFIZerV5EII",
            width: "433",
            height: "116",
          },
        ],
        metatags: [
          {
            "og:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/tesla-cars-social/bvlatuR/std/0x0/tesla-cars-social",
            "theme-color": "#000000",
            "twitter:card": "summary_large_image",
            "twitter:title":
              "Tesla Q4 2020 Vehicle Production & Deliveries | Tesla Investor Relations",
            "og:image:url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/tesla-cars-social/bvlatuR/std/0x0/tesla-cars-social",
            handheldfriendly: "true",
            "og:title":
              "Tesla Q4 2020 Vehicle Production & Deliveries | Tesla Investor Relations",
            "og:description":
              "PALO ALTO, Calif., January 2, 2021 – In 2020, we produced and delivered half a million vehicles, in line with our most recent guidance. In addition, Model Y production in Shanghai has begun, with deliveries expected to begin shortly.",
            "twitter:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/tesla-cars-social/bvlatuR/std/0x0/tesla-cars-social",
            "og:image:secure_url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/tesla-cars-social/bvlatuR/std/0x0/tesla-cars-social",
            viewport: "width=device-width, initial-scale=1.0",
            "twitter:description":
              "PALO ALTO, Calif., January 2, 2021 – In 2020, we produced and delivered half a million vehicles, in line with our most recent guidance. In addition, Model Y production in Shanghai has begun, with deliveries expected to begin shortly.",
            mobileoptimized: "width",
          },
        ],
        cse_image: [
          {
            src:
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/press_releases/S1dbei4/std/0x0/press_releases",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Model S | Tesla",
      htmlTitle: "Model S | \u003cb\u003eTesla\u003c/b\u003e",
      link: "https://www.tesla.com/models",
      displayLink: "www.tesla.com",
      snippet:
        "Model S is built for speed and range, with beyond ludicrous acceleration, \nunparalleled performance and a refined design.",
      htmlSnippet:
        "Model S is built for speed and range, with beyond ludicrous acceleration, \u003cbr\u003e\nunparalleled performance and a refined design.",
      cacheId: "Ei43u66-EP0J",
      formattedUrl: "https://www.tesla.com/models",
      htmlFormattedUrl:
        "https://www.\u003cb\u003etesla\u003c/b\u003e.com/models",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcSQ1fan4mNjyBJrn5X3l29Sjc_rlwKoOEL1bxndYeW0zp4dAt_8O2Wfb8IC",
            width: "311",
            height: "162",
          },
        ],
        metatags: [
          {
            "msapplication-tilecolor": "#cc0000",
            "og:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/56cb8c41-e898-44ce-b6b7-fe9b9a05f529/bvlatuR/std/1200x628/MS-Social",
            "twitter:card": "summary_large_image",
            "twitter:title": "Model S | Tesla",
            "theme-color": "#000000",
            "og:site_name": "Tesla",
            "og:image:url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/56cb8c41-e898-44ce-b6b7-fe9b9a05f529/bvlatuR/std/1200x628/MS-Social",
            handheldfriendly: "true",
            "twitter:url": "https://www.tesla.com/models",
            "og:title": "Model S",
            "msapplication-tileimage":
              "/themes/custom/tesla_frontend/assets/favicons/mstile-144x144.png",
            "twitter:creator": "@tesla",
            "og:description":
              "Model S is built for speed and range, with beyond ludicrous acceleration, unparalleled performance and a refined design.",
            "twitter:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/56cb8c41-e898-44ce-b6b7-fe9b9a05f529/bvlatuR/std/1200x628/MS-Social",
            "og:image:secure_url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/56cb8c41-e898-44ce-b6b7-fe9b9a05f529/bvlatuR/std/1200x628/MS-Social",
            "twitter:site": "@tesla",
            "apple-mobile-web-app-status-bar-style": "black",
            viewport: "width=device-width, initial-scale=1.0",
            "twitter:description":
              "Model S is built for speed and range, with beyond ludicrous acceleration, unparalleled performance and a refined design.",
            "apple-mobile-web-app-capable": "yes",
            mobileoptimized: "width",
            "og:url": "https://www.tesla.com/models",
          },
        ],
        cse_image: [
          {
            src:
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/56cb8c41-e898-44ce-b6b7-fe9b9a05f529/bvlatuR/std/1200x628/MS-Social",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Tesla the Band | Official Website | American Made Rock 'n' Roll",
      htmlTitle:
        "\u003cb\u003eTesla\u003c/b\u003e the Band | Official Website | American Made Rock &#39;n&#39; Roll",
      link: "https://teslatheband.com/",
      displayLink: "teslatheband.com",
      snippet:
        "The Official Website of the rock band Tesla, providing recent news, tour dates, \nmusic, history, and other ways for fans to interact.",
      htmlSnippet:
        "The Official Website of the rock band \u003cb\u003eTesla\u003c/b\u003e, providing recent news, tour dates, \u003cbr\u003e\nmusic, history, and other ways for fans to interact.",
      cacheId: "Pw3S9NsLmboJ",
      formattedUrl: "https://teslatheband.com/",
      htmlFormattedUrl: "https://\u003cb\u003etesla\u003c/b\u003etheband.com/",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcQj0Cz3qQotoHoZOO9Jro6e2jrHOWKwrH87bJcUVCT9zc_DyxxFtqt7vzo",
            width: "310",
            height: "163",
          },
        ],
        metatags: [
          {
            "og:image":
              "https://teslatheband.com/wp-content/uploads/2018/03/cropped-home-hero-1.jpg",
            "og:image:width": "3840",
            "og:type": "website",
            "twitter:card": "summary_large_image",
            "twitter:title":
              "Tesla the Band | Official Website | American Made Rock 'n' Roll",
            "og:site_name": "TESLA BAND | Official Website",
            "og:title":
              "Tesla the Band | Official Website | American Made Rock 'n' Roll",
            "og:image:height": "2016",
            "twitter:image:height": "2016",
            "msapplication-tileimage":
              "/wp-content/uploads/2018/04/cropped-tesla-logo-1-270x270.png",
            "og:description":
              "The Official Website of the rock band Tesla, providing recent news, tour dates, music, history, and other ways for fans to interact.",
            "twitter:image":
              "https://teslatheband.com/wp-content/uploads/2018/03/cropped-home-hero-1.jpg",
            "twitter:image:width": "3840",
            viewport: "width=device-width, initial-scale=1, shrink-to-fit=no",
            "twitter:description":
              "The Official Website of the rock band Tesla, providing recent news, tour dates, music, history, and other ways for fans to interact.",
            "og:locale": "en_US",
            "og:url": "https://teslatheband.com/",
          },
        ],
        cse_image: [
          {
            src:
              "https://teslatheband.com/wp-content/uploads/2018/03/cropped-home-hero-1.jpg",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Model 3 | Tesla",
      htmlTitle: "Model 3 | \u003cb\u003eTesla\u003c/b\u003e",
      link: "https://www.tesla.com/model3",
      displayLink: "www.tesla.com",
      snippet:
        "Tesla All-Wheel Drive has two independent motors for improved redundancy, \neach with only one moving part for minimal maintenance and maximum durability\n.",
      htmlSnippet:
        "\u003cb\u003eTesla\u003c/b\u003e All-Wheel Drive has two independent motors for improved redundancy, \u003cbr\u003e\neach with only one moving part for minimal maintenance and maximum durability\u003cbr\u003e\n.",
      cacheId: "N4-C0Xr0P-gJ",
      formattedUrl: "https://www.tesla.com/model3",
      htmlFormattedUrl:
        "https://www.\u003cb\u003etesla\u003c/b\u003e.com/model3",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSUJfAMM2tg3jkc-O42gXv0qCKhk944QQTVtP42EFcQz0Zl4X4IrHLSRlAW",
            width: "311",
            height: "162",
          },
        ],
        metatags: [
          {
            "msapplication-tilecolor": "#cc0000",
            "og:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/c82315a6-ac99-464a-a753-c26bc0fb647d/bvlatuR/std/1200x628/lhd-model-3-social",
            "twitter:card": "summary",
            "twitter:title": "Model 3 | Tesla",
            "og:image:alt": "Model 3",
            "theme-color": "#000000",
            "og:site_name": "Tesla",
            "og:image:url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/c82315a6-ac99-464a-a753-c26bc0fb647d/bvlatuR/std/1200x628/lhd-model-3-social",
            handheldfriendly: "true",
            "twitter:url": "https://www.tesla.com/model3",
            "og:title": "Model 3 | Tesla",
            "msapplication-tileimage":
              "/themes/custom/tesla_frontend/assets/favicons/mstile-144x144.png",
            "twitter:creator": "@Tesla",
            "og:description":
              "Model 3 is designed for electric-powered performance, with dual motor AWD, quick acceleration, long range and fast charging.",
            "twitter:image":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/c82315a6-ac99-464a-a753-c26bc0fb647d/bvlatuR/std/1200x628/lhd-model-3-social",
            "og:image:secure_url":
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/c82315a6-ac99-464a-a753-c26bc0fb647d/bvlatuR/std/1200x628/lhd-model-3-social",
            "twitter:image:alt": "Model 3",
            "apple-mobile-web-app-status-bar-style": "black",
            viewport: "width=device-width, initial-scale=1.0",
            "twitter:description":
              "Model 3 is designed for electric-powered performance, with dual motor AWD, quick acceleration, long range and fast charging.",
            "apple-mobile-web-app-capable": "yes",
            mobileoptimized: "width",
            "og:url": "https://www.tesla.com/model3",
          },
        ],
        cse_image: [
          {
            src:
              "https://tesla-cdn.thron.com/delivery/public/image/tesla/c82315a6-ac99-464a-a753-c26bc0fb647d/bvlatuR/std/1200x628/lhd-model-3-social",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Tesla, Inc. - Wikipedia",
      htmlTitle: "\u003cb\u003eTesla\u003c/b\u003e, Inc. - Wikipedia",
      link: "https://en.wikipedia.org/wiki/Tesla,_Inc.",
      displayLink: "en.wikipedia.org",
      snippet:
        "Tesla, Inc. is an American electric vehicle and clean energy company based in \nPalo Alto, California. Tesla's current products include electric cars, battery energy\n ...",
      htmlSnippet:
        "\u003cb\u003eTesla\u003c/b\u003e, Inc. is an American electric vehicle and clean energy company based in \u003cbr\u003e\nPalo Alto, California. \u003cb\u003eTesla&#39;s\u003c/b\u003e current products include electric cars, battery energy\u003cbr\u003e\n&nbsp;...",
      cacheId: "ahl5uU9rAQMJ",
      formattedUrl: "https://en.wikipedia.org/wiki/Tesla,_Inc.",
      htmlFormattedUrl:
        "https://en.wikipedia.org/wiki/\u003cb\u003eTesla\u003c/b\u003e,_Inc.",
      pagemap: {
        hcard: [
          {
            url_text: "tesla.com",
            bday: "2003-07-01",
            fn: "Tesla, Inc.",
            nickname: "Tesla Motors, Inc. (2003–February 2017)",
            logo: "Headquarters in Palo Alto",
            category: "Public",
            url: "tesla.com",
          },
        ],
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwtQ4SIVjsbrM1rg23xZvICpXrQqApgHnt2ZmM27jPhRfXhEEG7GSEacU",
            width: "198",
            height: "255",
          },
        ],
        metatags: [
          {
            referrer: "origin",
            "og:image":
              "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Tesla_Motors.svg/1200px-Tesla_Motors.svg.png",
          },
        ],
        cse_image: [
          {
            src:
              "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Tesla_Motors.svg/1200px-Tesla_Motors.svg.png",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Tesla Tequila",
      htmlTitle: "\u003cb\u003eTesla\u003c/b\u003e Tequila",
      link: "https://shop.tesla.com/product/tesla-tequila",
      displayLink: "shop.tesla.com",
      snippet:
        "Introducing Tesla Tequila, an exclusive, premium 100% de agave tequila añejo \naged in French oak barrels, featuring a dry fruit and light vanilla nose with a ...",
      htmlSnippet:
        "Introducing \u003cb\u003eTesla\u003c/b\u003e Tequila, an exclusive, premium 100% de agave tequila añejo \u003cbr\u003e\naged in French oak barrels, featuring a dry fruit and light vanilla nose with a&nbsp;...",
      cacheId: "MTQ8GWQnMjIJ",
      formattedUrl: "https://shop.tesla.com/product/tesla-tequila",
      htmlFormattedUrl:
        "https://shop.\u003cb\u003etesla\u003c/b\u003e.com/product/\u003cb\u003etesla\u003c/b\u003e-tequila",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcSq11i8zdIegHKB9G67JFezlGJz_sfCVcYoXcR5xD9vOzWiYVDzp9M8GF0",
            width: "224",
            height: "224",
          },
        ],
        metatags: [
          {
            "msapplication-tilecolor": "#cc0000",
            "og:image":
              "https://www.tesla.com/ns_videos/commerce/content/dam/tesla/LIFESTYLE/ACCESSORIES_COLLECTIBLES/DRINKWARE/1617866-00-A_0.jpg",
            "og:type": "product",
            "twitter:card": "summary_large_image",
            "twitter:title": "Tesla Tequila",
            "twitter:site:id": "13298072",
            "og:title": "Tesla Tequila",
            "msapplication-tileimage": "/images/icons/mstile-144x144.png?2",
            "og:description":
              "Introducing Tesla Tequila, an exclusive, premium 100% de agave tequila añejo aged in French oak barrels, featuring a dry fruit and light vanilla nose with a balanced cinnamon pepper finish.",
            "twitter:creator": "@teslamotors",
            "twitter:image":
              "https://www.tesla.com/ns_videos/commerce/content/dam/tesla/LIFESTYLE/ACCESSORIES_COLLECTIBLES/DRINKWARE/1617866-00-A_0.jpg",
            "twitter:site": "@teslamotors",
            "twitter:creator:id": "13298072",
            viewport: "width=device-width, initial-scale=1",
            "twitter:description":
              "Introducing Tesla Tequila, an exclusive, premium 100% de agave tequila añejo aged in French oak barrels, featuring a dry fruit and light vanilla nose with a balanced cinnamon pepper finish.",
          },
        ],
        cse_image: [
          {
            src:
              "https://www.tesla.com/ns_videos/commerce/content/dam/tesla/LIFESTYLE/ACCESSORIES_COLLECTIBLES/DRINKWARE/1617866-00-A_0.jpg",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Nikola Tesla - Wikipedia",
      htmlTitle: "Nikola \u003cb\u003eTesla\u003c/b\u003e - Wikipedia",
      link: "https://en.wikipedia.org/wiki/Nikola_Tesla",
      displayLink: "en.wikipedia.org",
      snippet:
        "Nikola Tesla was a Serbian-American inventor, electrical engineer, mechanical \nengineer, and futurist best known for his contributions to the design of the ...",
      htmlSnippet:
        "Nikola \u003cb\u003eTesla\u003c/b\u003e was a Serbian-American inventor, electrical engineer, mechanical \u003cbr\u003e\nengineer, and futurist best known for his contributions to the design of the&nbsp;...",
      cacheId: "ffC4b7aiemYJ",
      formattedUrl: "https://en.wikipedia.org/wiki/Nikola_Tesla",
      htmlFormattedUrl:
        "https://en.wikipedia.org/wiki/Nikola_\u003cb\u003eTesla\u003c/b\u003e",
      pagemap: {
        hcard: [
          {
            note:
              "Projects Alternating current high-voltage, high-frequency power experiments",
            bday: "1856-07-10",
            fn: "Nikola Tesla",
            nickname: "Никола Тесла",
            label: "Nikola Tesla Museum Belgrade, Serbia",
            category: "Austrian (1856–1891) American (1891–1943)",
          },
        ],
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcQWCFn1zDwTQIBRF9VDd9IfsyYKVtv2UGWDYFby88mPDxjm7AZ3P5uZLbk",
            width: "196",
            height: "257",
          },
        ],
        metatags: [
          {
            referrer: "origin",
            "og:image":
              "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/N.Tesla.JPG/1200px-N.Tesla.JPG",
          },
        ],
        cse_image: [
          {
            src:
              "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/N.Tesla.JPG/1200px-N.Tesla.JPG",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Tesla (@Tesla) | Twitter",
      htmlTitle:
        "\u003cb\u003eTesla\u003c/b\u003e (@\u003cb\u003eTesla\u003c/b\u003e) | Twitter",
      link: "https://twitter.com/tesla?lang=en",
      displayLink: "twitter.com",
      snippet:
        "The latest Tweets from Tesla (@Tesla). electric cars, giant batteries and solar.",
      htmlSnippet:
        "The latest Tweets from \u003cb\u003eTesla\u003c/b\u003e (@\u003cb\u003eTesla\u003c/b\u003e). electric cars, giant batteries and solar.",
      cacheId: "EA6z_IGqBJUJ",
      formattedUrl: "https://twitter.com/tesla?lang=en",
      htmlFormattedUrl:
        "https://twitter.com/\u003cb\u003etesla\u003c/b\u003e?lang=en",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcSYo1-BDaWz7OWvo4rC3DYSk0BMIDlrgsunbJWC8C-YWW9FHubtYtyC5PXw",
            width: "225",
            height: "225",
          },
        ],
        xfn: [{}],
        metatags: [
          {
            "msapplication-tilecolor": "#00aced",
            "al:android:url": "twitter://user?screen_name=Tesla",
            "al:ios:app_name": "Twitter",
            "swift-page-section": "profile",
            "al:android:package": "com.twitter.android",
            "swift-page-name": "profile",
            "msapplication-tileimage":
              "//abs.twimg.com/favicons/win8-tile-144.png",
            "al:ios:url": "twitter://user?screen_name=Tesla",
            "al:ios:app_store_id": "333903271",
            "al:android:app_name": "Twitter",
          },
        ],
        cse_image: [
          {
            src:
              "https://pbs.twimg.com/profile_images/1337607516008501250/6Ggc4S5n_400x400.png",
          },
        ],
      },
    },
    {
      kind: "customsearch#result",
      title: "Tesla Inc TSLA:NASDAQ",
      htmlTitle: "\u003cb\u003eTesla\u003c/b\u003e Inc TSLA:NASDAQ",
      link: "https://www.cnbc.com/quotes/TSLA",
      displayLink: "www.cnbc.com",
      snippet:
        "Get Tesla Inc (TSLA:NASDAQ) real-time stock quotes, news, price and financial \ninformation from CNBC.",
      htmlSnippet:
        "Get \u003cb\u003eTesla\u003c/b\u003e Inc (TSLA:NASDAQ) real-time stock quotes, news, price and financial \u003cbr\u003e\ninformation from CNBC.",
      cacheId: "m3nMYXJI7psJ",
      formattedUrl: "https://www.cnbc.com/quotes/TSLA",
      htmlFormattedUrl: "https://www.cnbc.com/quotes/TSLA",
      pagemap: {
        cse_thumbnail: [
          {
            src:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeZNwGjuwj2R8mk-B_fNrrBEAZqzp1fStevzprMkycFjuNE2mZrtOIenaR",
            width: "310",
            height: "163",
          },
        ],
        metatags: [
          {
            "og:image":
              "https://sc.cnbcfm.com/applications/cnbc.com/staticcontent/img/cnbc_logo.gif",
            "apple-itunes-app": "app-id=398018310",
            "og:type": "website",
            "twitter:card": "summary",
            "twitter:title":
              "Check out Tesla's stock price (TSLA) in real time",
            "og:site_name": "CNBC",
            "al:ios:app_name": "CNBC Business News and Finance",
            "twitter:url": "https://www.cnbc.com/quotes/TSLA",
            "og:title": "Check out Tesla's stock price (TSLA) in real time",
            title: "TSLA: Tesla Inc - Stock Price, Quote and News - CNBC",
            "og:description":
              "Get Tesla Inc (TSLA:NASDAQ) real-time stock quotes, news, price and financial information from CNBC.",
            "parsely-metadata":
              '{"nodeid": "101","originalImage": "https://sc.cnbcfm.com/applications/cnbc.com/resources/img/editorial/2015/03/30/102546467-Most-Popular--Image-Placeholder-Large.jpg"}',
            "article:publisher": "https://www.facebook.com/CNBC",
            "article:author": "https://www.facebook.com/CNBC",
            "al:ios:app_store_id": "398018310",
            referrer: "unsafe-url",
            "parsely-type": "post",
            "twitter:site": "@CNBC",
            viewport: "initial-scale=1.0, width=device-width",
            "og:url": "https://www.cnbc.com/quotes/TSLA",
          },
        ],
        cse_image: [
          {
            src:
              "https://sc.cnbcfm.com/applications/cnbc.com/staticcontent/img/cnbc_logo.gif",
          },
        ],
      },
    },
  ],
};
